import { ReactElement } from "react";
import { IIconProps } from "../types";

export default function IconPlus({ color, size }: IIconProps): ReactElement {
  return (
    <svg
      height={size || 24}
      width={size || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6667 6H11.3333V11.3333H6V12.6667H11.3333V18H12.6667V12.6667H18V11.3333H12.6667V6Z"
        fill={color || "#509EE3"}
      />
    </svg>
  );
}
